import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_Product_Condition_Type_Search_Fields: {[id:string]: ISearchProviderField } = {
    PRD_CNDM_ID:          {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Right}, domainOptions: {}},
    CONDITION_TYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Condition Id', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CONDITION_TYPE_NAME:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    COMMENTS:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Comments', columnResourceName: 'colComments', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SALESAREA_POLICY:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Enterprise Policy', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50, domainIds: 'Sales_Area_Policy', useIdAsKey: true}},
    DATE_INTERVAL_POLICY: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Date Policy', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50, domainIds: 'Date_Interval_Policy', useIdAsKey: true}},
    VALUE_UOM_POLICY:     {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'UOM Policy', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1}},
    WB_MDSET_ID:          {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colConditionId', alignment: HorizAlignment.Right}, domainOptions: {}},
    MDSET_ID:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Master Data Set Id', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    MDSET_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true}},
    CUSTOMER_ENTITY_ID:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Level Id', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUSTOMER_ENTITY_NAME: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Level', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true}},
    PRODUCT_ENTITY_ID:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Level Id', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_ENTITY_NAME:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Level', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true}},
    POLICYAREA_ID:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Policy Area Id', columnResourceName: 'colPolicyAreaId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    POLICYAREA_NAME:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Policy Area Name', columnResourceName: 'colPolicyAreaName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true}},
    POLICY_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Policy Id', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    POLICY_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Policy', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true}},
    POLICY_CUBENAME:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Cube', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true}},
    RESERVED_TERM_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Reserved Term', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50, domainIds: 'POLICY_RESERVED_TERM', useIdAsKey: true}},
    SOURCE_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source', columnResourceName: 'colSource', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50, bUseSearchProvidersDistinctValues: true}},
    ENTERPRISE_SET_ID:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Set Id', columnResourceName: 'colSource', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUSTOMER_TYPE:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Type', columnResourceName: 'colCustomerType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRDGRP_LEVEL_ID:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Group Level', columnResourceName: 'colProductGroupLevel', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    NUMBER_VALUE_MIN:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Number Value Min', columnResourceName: 'colNumberValueMin', alignment: HorizAlignment.Left}, domainOptions: {}},
    NUMBER_VALUE_MAX:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Number Value Max', columnResourceName: 'colNumberValueMax', alignment: HorizAlignment.Left}, domainOptions: {}},
}

const vUI_Product_Condition_Type_Search_Fields_Error_Records: {[id:string]: ISearchProviderField } = {
    PRD_CNDM_ID:          {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Right}, domainOptions: {}},
    CUSTOMER_ID:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer ID', columnResourceName: 'colCustomerId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CUSTOMER_NAME:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name', columnResourceName: 'colCustomerName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    FUNDTYPE_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Fund Type Id', columnResourceName: 'colFundtypeId', alignment: HorizAlignment.Left}, domainOptions: {}},
    FUNDTYPE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Fund Type Name', columnResourceName: 'colFundTypeName', alignment: HorizAlignment.Left}, domainOptions: {}},
    CONDITION_TYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Condition Type', columnResourceName: 'colConditionId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_GROUP_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Group ID', columnResourceName: 'colProductGroupId', alignment: HorizAlignment.Left}, domainOptions: {}},
    PRODUCT_GROUP_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Group Name', columnResourceName: 'colProductGroupName', alignment: HorizAlignment.Left}, domainOptions: {}},
    VALUE_RATEAMOUNT:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Value Rate Amount', columnResourceName: 'colValueRateAmount', alignment: HorizAlignment.Left}, domainOptions: {}},
    EFFECTIVE_START_DT:         {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Effective Start Date', columnResourceName: 'colEffectiveStartDate', alignment: HorizAlignment.Left}, domainOptions: {}},
    EFFECTIVE_END_DT:         {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Effective End Date', columnResourceName: 'colEffectiveEndDate', alignment: HorizAlignment.Left}, domainOptions: {}},
    ERROR_REASON:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Error', columnResourceName: 'colErrorReason', alignment: HorizAlignment.Left}, domainOptions: {}},


}

const vUI_CustomerControl_ProductCondition: {[id:string]: ISearchProviderField } = {
    PROD_CND_ID:              {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    SOURCE_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left}, domainOptions: {}},
    REL_SOURCE_ID:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Rel Source ID', columnResourceName: 'colRelSourceName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CONDITION_TYPE:         {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Condition Type', columnResourceName: 'colConditionType', alignment: HorizAlignment.Left}, domainOptions: {}},
    PRODUCT_ID:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product ID', columnResourceName: 'colProductID', alignment: HorizAlignment.Left}, domainOptions: {}},
    EFFECTIVE_START_DT:      {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective Start Date', columnResourceName: 'colEffectiveStartDate', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EFFECTIVE_END_DT:        {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Effective End Date', columnResourceName: 'colEffectiveEndDate', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}}
};

const ProductConditionTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'PRD_CNDM_ID',
                id_ui: 'CONDITION_TYPE',
                name:  'CONDITION_TYPE_NAME'},


    searchProviderFields: vUI_Product_Condition_Type_Search_Fields,

    async search(searchOptions: ISearchRequestSubset): Promise<any[]> {


            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_ProductConditionType_Search',
                this.searchProviderFields,
                [])

            return await PASearch.findByRequest(findRequest)
    },
    async distinctValues(fieldName: string): Promise<string[] | number[]> {


        let findRequest = SearchUtils.makeSearchRequest({},
            'vUI_ProductConditionType_Search',
            this.searchProviderFields,
            [fieldName])


        let res = await PASearch.findByRequest(findRequest)

        return _.map(res, (aRow) => { return aRow[fieldName]})
    }
}


const ProductConditionTypeSearchErrorProviderBasic: ISearchProvider = {

    keyFields: {id: 'PRD_CNDM_ID',
                id_ui: 'CONDITION_TYPE',
                name:  'CONDITION_TYPE_NAME'},


    searchProviderFields: vUI_Product_Condition_Type_Search_Fields_Error_Records,

    async search(searchOptions: ISearchRequestSubset): Promise<any[]> {


            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vProd_Cnd_Dup2',
                this.searchProviderFields,
                [])

            return await PASearch.findByRequest(findRequest)
    }

}

const ProductConditionTypeSearchProductCondition: ISearchProvider =
    {
        keyFields: {id:    'PROD_CND_ID',
                    id_ui: 'SOURCE_ID',
                    name:  'REL_SOURCE_ID'},


        searchProviderFields: vUI_CustomerControl_ProductCondition,

        async search(searchOptions: ISearchRequestSubset): Promise<any[]> {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_CustomerControl_ProductCondition',
                this.searchProviderFields,
                [])

            findRequest.order = ['CONDITION_TYPE'];

            return await PASearch.findByRequest(findRequest)
        }

    }


const ProductConditionTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ProductConditionTypeSearchProfileByName" },


    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'CONDITION_TYPE', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'CONDITION_TYPE_NAME', renderOptions: { }},
        {profileFilterName: 'Master Data Set',    searchProviderFieldId: 'MDSET_NAME', bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Source',    searchProviderFieldId: 'SOURCE_ID', bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Customer Type',   searchProviderFieldId: 'CUSTOMER_ENTITY_NAME', bMultiSelect: true,  renderOptions: { }},
        {profileFilterName: 'Product Type',   searchProviderFieldId: 'PRODUCT_ENTITY_NAME', bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Policy',   searchProviderFieldId: 'POLICY_NAME', bMultiSelect: true, renderOptions: { }},
    ],  // ISearchFields
    profileDisplayFields: [
        'CONDITION_TYPE','CONDITION_TYPE_NAME','SOURCE_ID','MDSET_NAME','CUSTOMER_ENTITY_NAME','PRODUCT_ENTITY_NAME','SALESAREA_POLICY','DATE_INTERVAL_POLICY', 'POLICY_NAME','POLICY_CUBENAME','RESERVED_TERM_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)
    profileHiddenFields: [
      'COMMENTS', 'MDSET_ID','POLICY_ID','VALUE_UOM_POLICY','SOURCE_POLICY','PRD_CNDM_ID','ENTERPRISE_SET_ID'
    ],
    profileSearchProvider: ProductConditionTypeSearchProviderBasic,

    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}



const ProductConditionTypeSearchProfileByError: ISearchProfile = {
    profileId: "ByError",
    profileName: "Error Records",
    renderOptions: { ui5ResourceId: "ProductConditionTypeSearchProfileByError" },


    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'CONDITION_TYPE', renderOptions: { }},
        // {profileFilterName: 'Name',   searchProviderFieldId: 'CONDITION_TYPE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','FUNDTYPE_ID','FUNDTYPE_NAME', 'CONDITION_TYPE','PRODUCT_GROUP_ID','PRODUCT_GROUP_NAME','VALUE_RATEAMOUNT','EFFECTIVE_START_DT','EFFECTIVE_END_DT','ERROR_REASON'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductConditionTypeSearchErrorProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const ProductConditionTypeControlProductCondition: ISearchProfile = {
    profileId: 'ControlProductCondition',
    profileName: "Control Product Condition",
    renderOptions: { ui5ResourceId: "ProductConditionTypeControlProductCondition"},

    profileFilter: [
        {profileFilterName: 'Product Condition',     searchProviderFieldId: 'PROD_CND_ID', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'PROD_CND_ID','SOURCE_ID','REL_SOURCE_ID', 'CONDITION_TYPE', 'PRODUCT_ID', 'EFFECTIVE_START_DT','EFFECTIVE_END_DT'    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductConditionTypeSearchProductCondition,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

var ProductConditionTypeSearch: ISearch = {
    searchName: "Find Product Condition Type",
    renderOptions: { ui5ResourceId: "ProductConditionTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ProductConditionTypeSearchProfileByName,ProductConditionTypeSearchProfileByError,ProductConditionTypeControlProductCondition],
    autoSearch: true
}
PAEnvironment.registerBusinessObjectSearch("ProductConditionTypeBO", "ProductConditionType", ProductConditionTypeSearch, "Product Condition Type Search")

export {ProductConditionTypeSearch}